import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import IndustryWiseMembers from "./IndustryWiseMembers";
import { IindustryWiseMemberResult } from "features/dashboard/api/types";
import { GetIndustryWiseMember } from "features/dashboard/api/hooks";
import IndustryWiseMemberChart from "./LinkCards";
import FormLoader from "components/Containers/FormLoader";
import QuickLinks from "./QuickLinks";

const IndustryWiseStatistics = () => {
  const [data, setData] = useState<IindustryWiseMemberResult>();

  const memberQuery = GetIndustryWiseMember();

  useEffect(() => {
    if (memberQuery.data?.status === 200) {
      setData(memberQuery?.data?.apiData);
    }
  }, [memberQuery.data]);

  return (
    <>
      <Grid container spacing={2.5} sx={{ my: 1 }}>
        <Grid item sm={12} md={4} xs={12}>
          <IndustryWiseMembers
            data={data?.industryWiseTabularMemberResult || []}
          />
        </Grid>
        {/* <Grid item sm={12} md={5} xl={5} xs={12}>
          {memberQuery.isFetching ? (
            <FormLoader />
          ) : (
            <QuickLinks data={data?.quickLinksResult || null} />
          )}
        </Grid> */}
        {/* <Grid item sm={12} md={3} xs={12}>
          <IndustryWiseMemberChart />
        </Grid> */}
      </Grid>
    </>
  );
};
export default IndustryWiseStatistics;
